import script from "./FloatingCta.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingCta.vue?vue&type=script&setup=true&lang=js"

import "./FloatingCta.vue?vue&type=style&index=0&id=35fabfee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35fabfee"]])

export default __exports__